<template>
  <component
    :is="type(error)"
    :to="href(error)"
    replace
  >
    {{ children(error) }}
  </component>
</template>

<script>
  export default {
    name: 'FormerFieldError',
    props: {
      error: {
        type: [String, Object],
        default: '',
      },
    },
    methods: {
      href(error) {
        return error && error.href;
      },

      type(error) {
        if ([null, undefined].indexOf(error) > -1 || typeof error === 'string') {
          return 'span';
        }

        if (typeof error === 'object' && error.href) {
          return 'router-link';
        }

        return this.item.errors[0];
      },

      children(error) {
        return (error && error.label) || error;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
